module.exports = __webpack_public_path__ + "img/slides-mobile.bcd15e10.png";